import React, { useEffect, useState } from 'react'
import SettingsEmptyState from '../../components/settings/SettingsEmptyState';
import { useCurrent, usePut } from '../../hooks';
import { MwButton, MwInputText, MwSpinnerButton, CardHeaderWithActions } from '../../components/ui';
import FormLangBar from '../../components/FormLangBar';
import { LangArrayToObjKeyValue, langObjType, objLangTextHandler } from '../../utils/global';
import { tenant } from '../../utils/tenantManager';
import { useTranslation } from 'react-i18next';

const MyBranches = ({refreshTenant}) => {
    const { currentLangList = [], currentLangId, currentCompanyId, currentTenantId, currentCompany } = useCurrent();
    const currentBranches = Array.isArray(currentCompany?.branches) ? currentCompany.branches : [];
    const {data:resultPut,loading,putData} = usePut();
    const [t] = useTranslation('global');
    const [mode, setMode] = useState('list');
    const [selectedBranchId, setSelectedBranchId] = useState(null);
    const [formLang, setFormLang] = useState(currentLangId);
    const [branchName, setBranchName] = useState(langObjType());

    useEffect(() => {
        setFormLang(currentLangId);
    }, [currentLangId]);

    const getLangText = (langArray, langCode) => {
        if (!langArray || !Array.isArray(langArray) || langArray.length === 0) {
            return '';
        }
        const langObj = LangArrayToObjKeyValue(langArray);
        if (langObj[langCode]) {
            return langObj[langCode];
        }
        if (langObj['en']) {
            return langObj['en'];
        }
        if (langObj['ar']) {
            return langObj['ar'];
        }
        const availableKeys = Object.keys(langObj);
        if (availableKeys.length > 0) {
            return langObj[availableKeys[0]];
        }
        return '';
    };

    const branchesSnapshot = JSON.stringify(
        (currentBranches || []).map(branch => ({
            id: branch?._id,
            name: branch?.name
        }))
    );

    useEffect(() => {
        if (!selectedBranchId) return;
        const branch = currentBranches.find(item => item?._id === selectedBranchId);
        if (!branch) return;
        const nextName = LangArrayToObjKeyValue(branch?.name) || {};
        setBranchName({ ...langObjType(), ...nextName });
    }, [selectedBranchId, branchesSnapshot]);

    useEffect(() => {
        if (resultPut && !loading) {
            refreshTenant?.();
            setMode('list');
        }
    }, [resultPut, loading, refreshTenant]);

    const startEdit = (branchId) => {
        setSelectedBranchId(branchId);
        setMode('edit');
    };

    const submitHandler = (e) => {
        e.preventDefault();
        if (!selectedBranchId) return;
        const nextBranches = (currentBranches || []).map(branch => {
            if (branch?._id !== selectedBranchId) return branch;
            return {
                ...branch,
                name: objLangTextHandler(branchName)
            };
        });

        const tenantData = tenant();
        const nextCompanies = (tenantData?.companies || []).map(company => {
            if (company?._id !== currentCompanyId) return company;
            return {
                ...company,
                branches: nextBranches
            };
        });

        putData(`${process.env.REACT_APP_Auth_API_BASE_URL}/tenants/${currentTenantId}`, {
            companies: nextCompanies
        });
    };

    if (mode === 'edit') {
        return (
            <div className='text-slate-500 bg-white rounded-lg text-xs p-3 h-full'>
                <CardHeaderWithActions title={t('setting.branchSettings')}>
                    <MwButton inGroup={true} type='cancelBtn' onClick={() => setMode('list')}>
                        {t('setting.manageBranches')}
                    </MwButton>
                    {loading ? <MwSpinnerButton/> : (
                        <MwButton inGroup={true} type='saveBtn' onClick={submitHandler}>
                            {t('setting.Save_changes')}
                        </MwButton>
                    )}
                </CardHeaderWithActions>
                <div className='p-3'>
                    <form onSubmit={submitHandler}>
                        <FormLangBar formLang={formLang} setFormLang={setFormLang} currentLangList={currentLangList} />
                        <div className='flex flex-col gap-1 py-1 md:flex-row md:gap-0'>
                            {currentLangList.map(lang => (
                                <div key={lang._id} className={`w-full ${formLang === lang.langCode ? 'block' : 'hidden'}`}>
                                    <MwInputText
                                        label={t('setting.branchName')}
                                        value={branchName?.[lang.langCode] || ''}
                                        onChange={(e) => setBranchName({ ...branchName, [lang.langCode]: e.target.value })}
                                    />
                                </div>
                            ))}
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div className='text-slate-500 bg-white rounded-lg text-xs p-3 h-full '>
            <CardHeaderWithActions title={t('setting.branchSettings')} />
            <div className='py-5'>
                {currentBranches.length > 0 ? (
                    <div className='flex flex-col gap-3'>
                        {currentBranches.map((branch) => (
                            <div key={branch?._id} className='flex items-center justify-between gap-2 p-3 rounded-lg border border-slate-200 bg-white'>
                                <div className='flex flex-col'>
                                    <span className='font-bold text-slate-600'>
                                        {getLangText(branch?.name, currentLangId) || t('customers.noData')}
                                    </span>
                                </div>
                                <MwButton type='saveBtn' size='sm' onClick={() => startEdit(branch?._id)}>
                                    {t('setting.editBranch')}
                                </MwButton>
                            </div>
                        ))}
                    </div>
                ) : (
                    <SettingsEmptyState msg={t('customers.noData')} />
                )}
            </div>
        </div>
    );
}

export default MyBranches
